import React from 'react';
import AntButton from 'antd/lib/button';
import IChecks from 'icons/IChecks';

const CheckButtonList = (otherProps: any) => {
  const props = {
    ...otherProps,
  };

  return <AntButton {...props} icon={<IChecks color="#00a896" />} />;
};

export default CheckButtonList;
